
import {take, filter} from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Component, OnInit, Input  } from '@angular/core';

import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';

import { formatCBLC } from '../../utils';
import { fadeInOutAnimation } from '@hub-workspace/apps/logged-home/src/app/shared/animations/fade-in-out-animation';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';

@Component({
    selector: 'bank-info-box',
    templateUrl: './bank-info-box.component.html',
    styleUrls: ['./bank-info-box.component.scss'],
    animations: [ fadeInOutAnimation ]
})
export class BankInfoBoxComponent implements OnInit {
    public isNewBrand: boolean = environment.isNewBrand

    @Input()
    public userCblc: string;

    @Input()
    public userCpfCnpj: string;

    public bankAnimState = { state: 'initial' };
    public cpfAnimState = { state: 'initial' };
    public agencyAnimState = { state: 'initial' };
    public accountAnimState = { state: 'initial' };

    constructor(
        public utilitiesService: UtilitiesService,
        private store: Store<AppState>
    ) {}

    public ngOnInit() {
        if (!this.userCblc) {
            this.store
                .select(({ authentication, userProfile }) => [ authentication.currentUser.cblc, userProfile.user.cpfcnpj ] as string[]).pipe(
                filter(([cblc, cpfCnpj]) => !!cblc && !!cpfCnpj),
                take(1),)
                .subscribe(([cblc, cpfCnpj]) => {
                    this.userCblc = formatCBLC(cblc);
                    this.userCpfCnpj = cpfCnpj;
                });
        } else {
            this.userCblc = formatCBLC(this.userCblc);
        }
    }

    /**
     * Helper para copiar um texto para a área de transferência do usuário
     * @param {string} item a ser copiado para a área de transferência
     */
    public copyToClipboard(value: string, animateState: { state: string }) {

        animateState.state = 'final';
        setTimeout(() => animateState.state = 'initial', 2000);

        document.addEventListener('copy', (event: ClipboardEvent) => {
            event.clipboardData.setData('text/plain', value);
            event.preventDefault();
            document.removeEventListener('copy', null);
        });

        document.execCommand('copy');

    }
}
